import { render, staticRenderFns } from "./PaymentSuccessFaqSection.vue?vue&type=template&id=704db30e"
import script from "./PaymentSuccessFaqSection.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessFaqSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports